module.exports = __webpack_public_path__ + "img/img-a256be81.04638009.png";